import { FullNameWithHabilitation } from '../types';
import { HabilitationI18nMap } from '../types/habilitation-i18n-map';
import { formatNameWithTitles } from './format-name-with-titles';

export const strictFormatNameWithTitles =
  <H extends string>(habilitationI18n: HabilitationI18nMap<H>) =>
  (data?: FullNameWithHabilitation<H>, fallback = '-'): string => {
    if (!data) return fallback;
    if (!((data.firstName || data.name) && (data.lastName || data.surname))) return fallback;
    return formatNameWithTitles<H>(habilitationI18n)(data, fallback);
  };
